export function lift(source, operator) {
    if (hasLift(source)) {
        return source.lift(operator);
    }
    throw new TypeError('Unable to lift unknown Observable type');
}
export function stankyLift(source, liftedSource, operator) {
    if (hasLift(source)) {
        return source.lift.call(liftedSource, operator);
    }
    throw new TypeError('Unable to lift unknown Observable type');
}
function hasLift(source) {
    return source && typeof source.lift === 'function';
}
//# sourceMappingURL=lift.js.map